import * as api from './api';
import { PrintMenu } from './models/printMenu';

export const printMenuRequest = async ({
  menuGuid, selectDay, saleZoneGuid, serviceGuid, languageGuid, selectedSections
}) => {
  const response = await api.printMenuRequest(menuGuid, selectDay, saleZoneGuid, serviceGuid, languageGuid, selectedSections);
  return PrintMenu.toInstance(response.data);
};
